var _defs, _g, _path, _g2, _g3, _g4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBegtestBil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 90.815 209.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11{fill:none;}.cls-2{fill:#1d1d1b;stroke:#1d1d1b;}.cls-10,.cls-11,.cls-2,.cls-4,.cls-5{stroke-miterlimit:10;}.cls-3{fill:#cdcccc;}.cls-4,.cls-8{fill:#fff;}.cls-10,.cls-11,.cls-4,.cls-5{stroke:#1a171b;}.cls-10,.cls-4,.cls-5{stroke-width:0.5px;}.cls-5{fill:#ededed;}.cls-6{opacity:0.46;}.cls-7{clip-path:url(#clip-path);}.cls-9{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-375.583 -204.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.735,281.894a3.766,3.766,0,0,0,4.725-2.879l4.353-25.417a96.7,96.7,0,0,0-63.626,0l4.352,25.417a3.767,3.767,0,0,0,4.725,2.879,42.324,42.324,0,0,1,7.215-1.2C418.106,279.586,435.718,279.744,443.735,281.894Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-375.583 -204.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M431.8,384.629c4.559-.072,10.974-3.828,13.487-5.417a2.069,2.069,0,0,0,.989-1.887l-.344-5.047a2.185,2.185,0,0,0-2.5-1.949c-1.619.206-4.014.51-7,.886a189.032,189.032,0,0,1-37.848-.886,2.185,2.185,0,0,0-2.5,1.949c-.283,4.152-.948,5.928.645,6.934,2.513,1.589,8.928,5.345,13.487,5.417C412.723,384.668,428.457,384.681,431.8,384.629Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wheels"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 24.685,
    width: 9.457,
    height: 26.909,
    rx: 2.377
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.857,
    y: 24.685,
    width: 9.457,
    height: 26.909,
    rx: 2.377
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 137.371,
    width: 9.457,
    height: 26.909,
    rx: 2.377
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.857,
    y: 137.371,
    width: 9.457,
    height: 26.909,
    rx: 2.377
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M457.514,379.853c2.659-2.517,2.3-6.835,3.792-13.626.524-2.384,1.21-13.25-.065-26.522a39.485,39.485,0,0,0-1.729-7.668,6.813,6.813,0,0,1-.327-2.087c.006-53.682.461-69.36.6-72.927a7.1,7.1,0,0,1,.3-1.722c3.076-10.545.288-29.666-.257-31.419a15.23,15.23,0,0,0-1.543-5.354c-1.542-3.528-4.242-4.136-8.74-7.908-3.889-3.26-13.444-5.156-15.964-5.611a6.792,6.792,0,0,0-1.2-.107H409.069a10.63,10.63,0,0,0-2.142.22c-2.935.607-10.829,2.461-14.453,5.5-4.5,3.772-7.2,4.38-8.74,7.908a15.238,15.238,0,0,0-1.542,5.354c-.547,1.754-3.336,20.882-.256,31.427a7.123,7.123,0,0,1,.3,1.712c.143,3.494.593,18.791.6,72.942a7.128,7.128,0,0,1-.351,2.142c-4.4,13.914-2.424,43.54,2.022,47.748,2.185,2.069,8.741,5.84,11.054,6.449a73.343,73.343,0,0,0,14.846,2.342C428.6,388.946,446.691,390.1,457.514,379.853Z",
    transform: "translate(-375.583 -204.402)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "lights"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M399.2,206.972c-5.632,1.976-6.649,2.748-10.184,6.013a.948.948,0,0,0-.305.68c-.022.878.071,2.775,1.372,2.017,8.3-4.834,11.008-5.557,10.813-6.775C400.712,207.733,400.326,206.578,399.2,206.972Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M441.428,207.628a1.058,1.058,0,0,1,1.368-.656c5.632,1.976,6.649,2.748,10.183,6.013a.945.945,0,0,1,.306.68c.022.878-.071,2.775-1.372,2.017C440.656,209.125,440.567,210.44,441.428,207.628Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M450.722,381.612a.927.927,0,0,0-1.25-.031c-2.573,2.284-2.534,2.029-1.236,4.033a47.137,47.137,0,0,0,4.252-2.263Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M394.226,383.089c-2.648-2.35-2.049-2.363-4.714.262a47.122,47.122,0,0,0,4.252,2.263C394.391,384.646,395.1,383.864,394.226,383.089Z",
    transform: "translate(-375.583 -204.402)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "windows"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M387.066,265.951v34.156a1.183,1.183,0,0,0,.5.971l3.263,2.275a1.115,1.115,0,0,0,1.735-.971c0-10.931.548-13.528-2.747-27.862A47.755,47.755,0,0,0,387.066,265.951Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M387.066,309.389v29.257c0,1.5,1.678,1.147,3.182,1.147,2.946.909,2.511-9.634,2.322-29.531a1.111,1.111,0,0,0-.789-1.1l-3.475-.9A1.053,1.053,0,0,0,387.066,309.389Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M388.03,347.347c.861,11.156,1.067,19.741,3.214,16.652a10.46,10.46,0,0,0,1.928-6.082c.193-2.968,0-16.144,0-16.144Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M443.735,281.894a3.766,3.766,0,0,0,4.725-2.879l4.353-25.417a96.7,96.7,0,0,0-63.626,0l4.352,25.417a3.767,3.767,0,0,0,4.725,2.879,42.324,42.324,0,0,1,7.215-1.2C418.106,279.586,435.718,279.744,443.735,281.894Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M431.8,384.629c4.559-.072,10.974-3.828,13.487-5.417a2.069,2.069,0,0,0,.989-1.887l-.344-5.047a2.185,2.185,0,0,0-2.5-1.949c-1.619.206-4.014.51-7,.886a189.032,189.032,0,0,1-37.848-.886,2.185,2.185,0,0,0-2.5,1.949c-.283,4.152-.948,5.928.645,6.934,2.513,1.589,8.928,5.345,13.487,5.417C412.723,384.668,428.457,384.681,431.8,384.629Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Highlight_back",
    "data-name": "Highlight back",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "14.457 103.839 6.531 103.839 58.455 30.325 66.382 30.325 14.457 103.839"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "24.981 103.839 21.017 103.839 72.942 30.325 76.905 30.325 24.981 103.839"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Highlight_front",
    "data-name": "Highlight front",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "14.457 209.842 6.531 209.842 58.455 136.327 66.382 136.327 14.457 209.842"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "24.981 209.842 21.017 209.842 72.942 136.327 76.905 136.327 24.981 209.842"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "outline_back",
    "data-name": "outline back",
    className: "cls-10",
    d: "M443.735,281.894a3.766,3.766,0,0,0,4.725-2.879l4.353-25.417a96.7,96.7,0,0,0-63.626,0l4.352,25.417a3.767,3.767,0,0,0,4.725,2.879,42.324,42.324,0,0,1,7.215-1.2C418.106,279.586,435.718,279.744,443.735,281.894Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "outline_back-2",
    "data-name": "outline back",
    className: "cls-10",
    d: "M431.8,384.629c4.559-.072,10.974-3.828,13.487-5.417a2.069,2.069,0,0,0,.989-1.887l-.344-5.047a2.185,2.185,0,0,0-2.5-1.949c-1.619.206-4.014.51-7,.886a189.032,189.032,0,0,1-37.848-.886,2.185,2.185,0,0,0-2.5,1.949c-.283,4.152-.948,5.928.645,6.934,2.513,1.589,8.928,5.345,13.487,5.417C412.723,384.668,428.457,384.681,431.8,384.629Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M454.933,265.951v34.156a1.18,1.18,0,0,1-.5.971l-3.262,2.275a1.115,1.115,0,0,1-1.735-.971c0-.537-.033-12.537.051-13.064C450.907,280.369,452.431,271.349,454.933,265.951Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M454.933,309.389c0,29.442.645,30.4-1.014,30.4h-2.167c-2.946.909-2.512-9.634-2.322-29.531a1.111,1.111,0,0,1,.788-1.1l3.476-.9A1.052,1.052,0,0,1,454.933,309.389Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M453.969,347.347c-.861,11.156-1.066,19.741-3.213,16.652-2.27-3.268-2.179-5.1-1.928-22.226Z",
    transform: "translate(-375.583 -204.402)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "mirrors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M387.9,262.649l-.514-2.452c-6.251-1.468-10.9.848-10.99,2.648-.1,2.007-1.052,3.776,8.29.981Z",
    transform: "translate(-375.583 -204.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M454.1,262.649l.514-2.452c6.251-1.468,10.9.848,10.99,2.648.1,2.007,1.052,3.776-8.291.981Z",
    transform: "translate(-375.583 -204.402)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Car_outline",
    "data-name": "Car outline",
    className: "cls-11",
    d: "M465.6,262.845c-.061-1.264-2.378-2.777-5.914-3.061.032-1.155.06-1.991.081-2.561a8.965,8.965,0,0,1,.357-2.1c2.994-10.58.235-29.5-.308-31.243a15.238,15.238,0,0,0-1.542-5.354c-1.543-3.528-4.242-4.136-8.741-7.908-3.754-3.147-12.789-5.023-15.677-5.558a9.423,9.423,0,0,0-1.733-.16H408.954a9.4,9.4,0,0,0-1.878.188c-2.8.57-10.92,2.436-14.611,5.53-4.5,3.772-7.2,4.38-8.741,7.908a15.238,15.238,0,0,0-1.542,5.354c-.543,1.744-3.3,20.661-.308,31.243a8.981,8.981,0,0,1,.359,2.088c.022.568.051,1.4.083,2.571-3.538.283-5.857,1.8-5.918,3.061-.089,1.828-.885,3.456,6.026,1.623.18,9.209.4,27.953.4,65.068a9.066,9.066,0,0,1-.391,2.7c-4.345,13.967-2.37,43.422,2.062,47.617,2.186,2.069,8.741,5.84,11.055,6.449a73.33,73.33,0,0,0,14.846,2.342c18.192.3,36.285,1.454,47.108-8.791,2.66-2.517,2.3-6.835,3.792-13.626.524-2.384,1.211-13.25-.064-26.522a38.761,38.761,0,0,0-1.618-7.32,9.533,9.533,0,0,1-.439-2.86c.006-36.956.225-55.784.406-65.056C466.487,266.3,465.691,264.672,465.6,262.845Z",
    transform: "translate(-375.583 -204.402)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBegtestBil);
export default __webpack_public_path__ + "static/media/begtest-bil.6d79827b0f6564abfa5ce1be5c611eb7.svg";
export { ForwardRef as ReactComponent };